<div class="ds-page-header">
  @if (showBack) {
    <button type="button" class="btn btn-outline-secondary ds-page-header__back" (click)="onBack()">
      <i class="ft ft-arrow-left"></i>
    </button>
  }
  <div class="ds-page-header__copy">
    <h1 class="ds-page-header__title">{{ title }}</h1>
    @if (subtitle) {
      <p class="ds-page-header__subtitle">{{ subtitle }}</p>
    }
  </div>
  <div class="ds-page-header__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
